<template>
    <div ref="modalConfirm" class="modal mx-0 fade modal-second" tabindex="-1" role="dialog" id="modalConfirm">
        <div class="modal-dialog modal-lg" role="document" style="width: 800px">
            <div class="modal-content px-4">
                <div class="modal-header py-1">
                    <h6 class="modal-title py-2">{{ $t('message.common.removeRole') }}</h6>
                    <button type="button" class="close" data-dismiss="modalConfirm" aria-label="Close" @click="clearData()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body my-4 py-0 mx-3 px-0" >
                    <div class="row">
                        <div class="col-12 pb-5">
                            <h6>{{$t('message.common.confirmRemoveRole')}}</h6>
                        </div>
                        <div class="col-12 d-flex justify-content-end">
                            <button class="btn btn-danger mr-2" @click="deleteData()">
                                <i class="fa fa-check mr-1"></i>
                                {{ $t('message.button.confirm') }}
                            </button>
                            <button class="btn btn-secondary text-white" data-dismiss="modalConfirm" aria-label="Close" @click="clearData()">
                                <i class="fa fa-ban mr-1"></i>
                                {{$t('message.button.cancel')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {$post } from "@/lib/utils";
import toastr from 'toastr';
export default {
    name: "ModalRemoveRole",
    components: {},
    data(){
        return {
            id: null,
        }
    },
    props: {},
    methods: {
        show(id) {
            if(id != null){
                this.id = id;
            }
            window.jQuery(this.$refs.modalConfirm).modal('show');
        },
        async deleteData(){
            const res = await $post('/v1/roles/remove', { id: this.id});
            if(res.result && res.result.status == false){
                toastr.error(res.result.message);
                this.clearData();
            }
            if(res.result && res.result.status){
                toastr.success(res.result.message);
                this.$emit('inputData','1');
                this.clearData();
            }
        },
        clearData(){
            window.jQuery(this.$refs.modalConfirm).modal('hide');
        },
    }
}
</script>

